
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"256","height":"256"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticStyle:{"stroke":"none","stroke-width":"0","stroke-dasharray":"none","stroke-linecap":"butt","stroke-linejoin":"miter","stroke-miterlimit":"10","fill":"none","fill-rule":"nonzero","opacity":"1"}},[_c('path',{staticStyle:{"stroke":"none","stroke-width":"1","stroke-dasharray":"none","stroke-linecap":"butt","stroke-linejoin":"miter","stroke-miterlimit":"10","fill":"#000","fill-rule":"nonzero","opacity":"1"},attrs:{"d":"M168.63 32.095a4.216 4.216 0 00-.48 5.94l72.823 85.607H5.622c-2.33 0-4.215 1.885-4.215 4.215s1.885 4.215 4.215 4.215h235.351l-72.824 85.606a4.215 4.215 0 006.42 5.463l78.734-92.556c.04-.045.054-.107.09-.152.197-.253.388-.511.526-.809.034-.073.045-.149.073-.222.036-.09.062-.177.09-.267.135-.419.225-.848.225-1.278 0-.43-.09-.86-.225-1.279-.028-.09-.054-.177-.09-.264-.028-.073-.042-.149-.076-.222-.138-.298-.329-.556-.525-.81-.037-.047-.051-.106-.09-.151L174.57 32.575a4.213 4.213 0 00-5.94-.48z"}})])])
          )
        }
      }
    